import { FolderOpenDot } from "lucide-react";
import { NavLink } from "react-router-dom";
import { SupportPopup } from "src/components/SupportPopup";
import { navLinkStyle } from "src/components/ui/navigation-menu";

export const NavItems = ({ onClick }: { onClick?: () => any }) => {
  return (
    <div>
      <NavLink className={navLinkStyle} to="/">
        <FolderOpenDot size={12} className="mr-1" />
        Loan application
      </NavLink>

      <SupportPopup types={["mortgage_specialist"]} />
    </div>
  );
};
